<template>
  <div ref="appEl" class="w-full h-full flex flex-col">
    <header class="bg-gray-200 p-3 border-b-1 border-black">
      <div class="flex flex-row gap-2">
        <span>select widget to test:</span>
        <select
          v-model="widgetSelection"
          @change="handleToggleWidget"
        >
          <option 
            v-for="(widget, widget_ndx) in widgets"
            :key="widget_ndx"
            class="bg-gray-300 text-white px-4 py-2 rounded-lg"
            :value="widget.id"
          >{{ widget.label }}</option>
        </select>
      </div>
    </header>
    <section class="flex-1 flex flex-col">
      <DemoPostTest v-if="currWidget.id === 'pik-posttest'" />
      <div v-else class="h-full flex-1 flex flex-row">
        <div class="w-1/2 h-full p-2">
        </div>
        <div class="w-1/2 h-full p-2 border-l-1 border-black">
        <section 
          class="demo-section"
          :class="{
            'overflow-y-hidden': currWidget.id === 'cme-information'
          }"
        >
          <template v-if="currWidget.id === 'breakingmed-feed'">
            <breakingmed-feed
              ta-num="66"
              show-subscribe="true"
              is-subscribed="1"
            ></breakingmed-feed>
            <breakingmed-feed
              mode="light"
              user-token="null"
              is-subscribed="null"
            ></breakingmed-feed>
          </template>
          <template v-else-if="currWidget.id === 'cognitive-search'">
            <cognitive-search
              id="cognitiveSearch"
              description="Donec varius at quam sed tempus,<br>Ut eget varius velit, eu vestibulum."
            ></cognitive-search>
          </template>
          <template v-else-if="currWidget.id === 'irae-search'">
            <irae-search
              id="iraeSearch"
            ></irae-search>
          </template>
          <template v-else-if="currWidget.id === 'pik-accordion'">
            <pik-accordion
              id="pikAccordion"
              title="Some Title"
              expand-type="multi"
              :default-expand="[2,5]"
              :list='[{"title": "<strong>Lorem</strong> Ipsum","body": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean tempor justo eu libero pellentesque auctor. Aliquam erat volutpat. Nullam et vehicula quam. Cras mauris magna, accumsan et ligula quis, mollis congue odio. Ut a augue ligula. Proin sagittis a augue quis tincidunt. Vivamus nisi lorem, vehicula vitae feugiat vitae, vehicula nec dui. Vestibulum venenatis massa turpis, eget tincidunt purus cursus non. Etiam eleifend erat turpis. Nam mi quam, tempus eget porta eget, ornare varius lorem. Nullam nec erat vitae mauris efficitur pulvinar ut ultricies turpis.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean tempor justo eu libero pellentesque auctor. Aliquam erat volutpat. Nullam et vehicula quam. Cras mauris magna, accumsan et ligula quis, mollis congue odio. Ut a augue ligula. Proin sagittis a augue quis tincidunt. Vivamus nisi lorem, vehicula vitae feugiat vitae, vehicula nec dui. Vestibulum venenatis massa turpis, eget tincidunt purus cursus non. Etiam eleifend erat turpis. Nam mi quam, tempus eget porta eget, ornare varius lorem. Nullam nec erat vitae mauris efficitur pulvinar ut ultricies turpis.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean tempor justo eu libero pellentesque auctor. Aliquam erat volutpat. Nullam et vehicula quam. Cras mauris magna, accumsan et ligula quis, mollis congue odio. Ut a augue ligula. Proin sagittis a augue quis tincidunt. Vivamus nisi lorem, vehicula vitae feugiat vitae, vehicula nec dui. Vestibulum venenatis massa turpis, eget tincidunt purus cursus non. Etiam eleifend erat turpis. Nam mi quam, tempus eget porta eget, ornare varius lorem. Nullam nec erat vitae mauris efficitur pulvinar ut ultricies turpis.</p>"},{"title": "Lorem Ipsum","body": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean tempor justo eu libero pellentesque auctor. Aliquam erat volutpat. Nullam et vehicula quam. Cras mauris magna, accumsan et ligula quis, mollis congue odio. Ut a augue ligula. Proin sagittis a augue quis tincidunt. Vivamus nisi lorem, vehicula vitae feugiat vitae, vehicula nec dui. Vestibulum venenatis massa turpis, eget tincidunt purus cursus non. Etiam eleifend erat turpis. Nam mi quam, tempus eget porta eget, ornare varius lorem. Nullam nec erat vitae mauris efficitur pulvinar ut ultricies turpis."},{"title": "Lorem Ipsum","body": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean tempor justo eu libero pellentesque auctor. Aliquam erat volutpat. Nullam et vehicula quam. Cras mauris magna, accumsan et ligula quis, mollis congue odio. Ut a augue ligula. Proin sagittis a augue quis tincidunt. Vivamus nisi lorem, vehicula vitae feugiat vitae, vehicula nec dui. Vestibulum venenatis massa turpis, eget tincidunt purus cursus non. Etiam eleifend erat turpis. Nam mi quam, tempus eget porta eget, ornare varius lorem. Nullam nec erat vitae mauris efficitur pulvinar ut ultricies turpis."},{"title": "Lorem Ipsum","body": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean tempor justo eu libero pellentesque auctor. Aliquam erat volutpat. Nullam et vehicula quam. Cras mauris magna, accumsan et ligula quis, mollis congue odio. Ut a augue ligula. Proin sagittis a augue quis tincidunt. Vivamus nisi lorem, vehicula vitae feugiat vitae, vehicula nec dui. Vestibulum venenatis massa turpis, eget tincidunt purus cursus non. Etiam eleifend erat turpis. Nam mi quam, tempus eget porta eget, ornare varius lorem. Nullam nec erat vitae mauris efficitur pulvinar ut ultricies turpis."},{"title": "Lorem Ipsum","body": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean tempor justo eu libero pellentesque auctor. Aliquam erat volutpat. Nullam et vehicula quam. Cras mauris magna, accumsan et ligula quis, mollis congue odio. Ut a augue ligula. Proin sagittis a augue quis tincidunt. Vivamus nisi lorem, vehicula vitae feugiat vitae, vehicula nec dui. Vestibulum venenatis massa turpis, eget tincidunt purus cursus non. Etiam eleifend erat turpis. Nam mi quam, tempus eget porta eget, ornare varius lorem. Nullam nec erat vitae mauris efficitur pulvinar ut ultricies turpis."}]'
            ></pik-accordion>
          </template>
          <template v-else-if="currWidget.id === 'ihp-banner'">
            <ihp-banner
              id="example"
            ></ihp-banner>
          </template>
          <template v-else-if="currWidget.id === 'ihp-banner-180x150'">
            <ihp-banner
              id="example"
              size="180x150"
            ></ihp-banner>
          </template>
          <template v-else-if="currWidget.id === 'pik-posttest'">
            <pik-posttest
              id="pikPreTestEl"
              ref="pikPreTestEl"
              jobnum="2642.02"
              token="d0983291a4f704b9b110fd428c53d6ca"
              @is-completed="(event) => handlePretestCompleted(event)"
              @loaded="initFancyBox"
              @skipped-all="handlePretestSkipped"
            ></pik-posttest>
          </template>
          <template v-else-if="currWidget.id === 'pik-pretest'">
            <pik-pretest
              id="pikPreTestEl"
              ref="pikPreTestEl"
              jobnum="2629.33"
              token="d0983291a4f704b9b110fd428c53d6ca"
              @is-completed="(event) => handlePretestCompleted(event)"
              @loaded="initFancyBox"
              @skipped-all="handlePretestSkipped"
            ></pik-pretest>
          </template>
          <template v-else-if="currWidget.id === 'cme-information'">
            <cme-information
              type="fixed"
              jobnum="2528.04"
              :has-close="false"
              bg-color="white"
            ></cme-information>
          </template>
          <template v-else-if="currWidget.id === 'universal-chatbot'">
            <universal-chatbot 
              id="universalChatbot"
              name="cidp"
            ></universal-chatbot>
          </template>
          <template v-else-if="currWidget.id === 'linkedin-tracker'">
            <linkedin-tracker
              id="linkedInTracker"
              jobnum="2621.63"
              is-known="false"
            ></linkedin-tracker>
          </template>
          <template v-else-if="currWidget.id === 'pik-auth'">
            <pik-auth
              class="rounded-xl shadow-lg"
              style="max-width:378px;"
            ></pik-auth>
          </template>
        </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { computed, onMounted, ref } from 'vue'
import store from '@/store'
import {
  DemoPostTest,
  UiLogo
} from '@/components'

// DOM
const appEl = ref(null)

// Variables
const widgetSelection = ref()

// Computed
const widgets = computed(() => {
  return store.getters?.widgets
})
const currWidget = computed(() => {
	return store.getters?.currWidget
})
// Life Cycle Hooks
onMounted(() => {
  widgetSelection.value = currWidget.value.id
})

const handleToggleWidget = () => {
  store.dispatch('clearWidgetSettings')
	store.dispatch('toggleWidget', {
		id: widgetSelection.value
	})
}
</script>

<style scoped>
.demo-section {
	position: relative;
	width: 100%;
	height: 100%;
}
</style>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_fontface.css"></style>
<style src="@/assets/css/_variables.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/_animations.css"></style>
<style src="@/assets/css/main.css"></style>